import {PLANNER_CREATE_PROJECT, PLANNER_CREATE_TASK, PLANNER_MATCH_PROJECT_ID, PLANNER_LENGTH_TASK_LIST, PLANNER_GET_CURRENT_STATUS, PLANNER_VALIDATION_DATE_WORKER} from './actionTypes'

export const createNewProject = (newProjectInput) => {
    return {
        type: PLANNER_CREATE_PROJECT,
        payload: newProjectInput
    }
}

export const createNewTask = (newTaskInput) => {
    return {
        type: PLANNER_CREATE_TASK,
        payload: newTaskInput
    }
}

export const matchProjectID = (projectID) => {
    return {
        type: PLANNER_MATCH_PROJECT_ID,
        payload: projectID
    }
}

export const getLengthTaskList = (inputTaskList) => {
    return {
        type: PLANNER_LENGTH_TASK_LIST,
        payload: inputTaskList
    }
}

export const getCurrentStatus = (currentStatusArr) => {
    return {
        type: PLANNER_GET_CURRENT_STATUS,
        payload: currentStatusArr
    }
}

export const getDateValidationWorker = (dateValidationWorker) => {
    return {
        type: PLANNER_VALIDATION_DATE_WORKER,
        payload: dateValidationWorker
    }
}
